import {
  createRouter,
  createRoute,
  createRootRoute,
  createHashHistory,
} from "@tanstack/react-router";

import { WebGlUIPage } from "./pages/WebGlUIPage";
import {
  object,
  number,
  boolean,
  parse,
  optional,
  union,
  literal,
} from "valibot";

// Define the search params schema
const webGlAppSearchSchema = object({
  resolution: optional(number(), Math.max(1, window.devicePixelRatio)),
  autoDensity: optional(boolean(), true),
  antialias: optional(boolean(), false),
  renderPreference: optional(
    union([literal("webgl"), literal("webgpu")]),
    "webgl"
  ),
  fpsMeter: optional(boolean(), true),
});

// Create a root route
const rootRoute = createRootRoute();

// Create the index route (root path)
const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  validateSearch: (search) => parse(webGlAppSearchSchema, search),
  component: () => <WebGlUIPage />,
});

const hashHistory = createHashHistory();

// Create the router
const router = createRouter({
  routeTree: rootRoute.addChildren([indexRoute]),
  history: hashHistory,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export { router };
